import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "clock",
  "use": "clock-usage",
  "viewBox": "0 0 23 23",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 23 23\" id=\"clock\"><g fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" transform=\"translate(1 1)\"><circle cx=\"10.5\" cy=\"10.5\" r=\"10.5\" /><path d=\"M10.5 4.2v6.3l4.2 2.1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol